import React from 'react'
import { Field } from 'redux-form'

import './PreferencesForm.scss'
import LabeledIconInput from 'components/LabeledIconInput'
import HoursCounter from 'components/HoursCounter'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'

const PreferencesForm = (props) => {
  const {
    handleSubmit
  } = props

  return (
    <div className='PreferencesForm navbar-screen'>
      <ProfileMobileNavBar>
        Preferencias
      </ProfileMobileNavBar>
      <div className='PreferencesForm-content navbar-screen-content'>
        <div className='navbar-screen-container'>
          <form onSubmit={handleSubmit}>
            <div className='PreferencesForm-Fields'>
              <div className='PreferencesForm-fieldsColumns'>
                <div className='PreferencesForm-fieldsColumn'>
                  <h4>Servicios que necesitas</h4>
                  <fieldset>
                    <legend>Elige las habilidades que necesitas de tu Aliada.</legend>
                    <div className='PreferencesForm-IconsWrapper'>
                      <div className='PreferencesForm-LabeledIconInputs'>
                        <Field
                          name='skills.cleaning'
                          id='skills.cleaning'
                          iconType='icon'
                          iconContent='broom'
                          type='checkbox'
                          label='Limpieza'
                          disabled
                          component={LabeledIconInput}
                        />
                        <Field
                          name='skills.laundry'
                          id='skills.laundry'
                          iconType='icon'
                          iconContent='washing-machine'
                          type='checkbox'
                          label='Lavar'
                          component={LabeledIconInput}
                        />
                        <Field
                          name='skills.ironing'
                          id='skills.ironing'
                          iconType='icon'
                          iconContent='iron'
                          type='checkbox'
                          label='Planchar'
                          component={LabeledIconInput}
                        />
                        <Field
                          name='skills.cooking'
                          id='skills.cooking'
                          iconType='icon'
                          iconContent='pot'
                          type='checkbox'
                          label='Cocinar'
                          component={LabeledIconInput}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className='PreferencesForm-fieldsColumn'>
                  <h4>Información adicional</h4>
                  <fieldset>
                    <legend>¿Tienes mascotas?</legend>
                    <div className='PreferencesForm-IconsWrapper'>
                      <div className='PreferencesForm-LabeledIconInputs'>

                        <Field
                          name='preferences.pets'
                          id='preferences.pets'
                          iconType='icon'
                          iconContent='pet'
                          type='checkbox'
                          label='Mascotas'
                          component={LabeledIconInput}
                        />
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <fieldset>
                <legend className='text-center'>Duración del servicio</legend>
                <Field
                  name='estimatedHours'
                  min={4}
                  max={8}
                  formatValue={value => `${value} hrs`}
                  component={HoursCounter}
                />
              </fieldset>
            </div>
            <div className='PreferencesForm-Footer'>
              <button type='submit' className='btn btn-default btn-block btn-lg'>Continuar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default PreferencesForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/PreferencesForm/PreferencesForm.js